<template>
  <div class="consultation-form-container">
    <div class="consultation-form-title mb-3">지금 바로 시작하세요</div>
    <div class="consultation-form-description mb-10">
      아래의 폼을 제출해주시면, <span class="mobile" />담당자가 24시간 이내에 연락드릴 예정입니다.
    </div>
    <div class="consultation-form">
      <form @submit.prevent="submitForm" class="form-container">
        <!-- Form Fields -->
        <div class="form-row">
          <div class="form-group">
            <label for="contact-name">담당자 이름 *</label>
            <input id="contact-name" v-model="formData.contactName" type="text" class="form-input" required />
          </div>
          <div class="form-group">
            <label for="company-name">회사명 *</label>
            <input id="company-name" v-model="formData.companyName" type="text" class="form-input" required />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="phone">전화번호 *</label>
            <input id="phone" v-model="formData.phone" type="tel" class="form-input" required />
          </div>
          <div class="form-group">
            <label for="position">직책 *</label>
            <input id="position" v-model="formData.position" type="text" class="form-input" required />
          </div>
        </div>

        <div class="form-group full-width">
          <label for="email">이메일 *</label>
          <input id="email" v-model="formData.email" type="email" class="form-input" required />
        </div>

        <!-- Radio Button Section -->
        <div class="form-group full-width">
          <label class="radio-label">수출바우처 참여 기업 여부 *</label>
          <div class="radio-group">
            <div
              class="radio-option"
              @click="formData.isExportVoucher = true"
              :class="{ selected: formData.isExportVoucher === true }">
              <input id="yes" v-model="formData.isExportVoucher" type="radio" value="true" name="exportVoucher" />
              <label for="yes" class="radio-text" :class="{ selected: formData.isExportVoucher === true }">예</label>
            </div>
            <div
              class="radio-option"
              @click="formData.isExportVoucher = false"
              :class="{ selected: formData.isExportVoucher === false }">
              <input id="no" v-model="formData.isExportVoucher" type="radio" value="false" name="exportVoucher" />
              <label for="no" class="radio-text" :class="{ selected: formData.isExportVoucher === false }"
                >아니오</label
              >
            </div>
          </div>
        </div>

        <!-- Notice -->
        <div class="notice-section">
          <div class="notice-icon">
            <v-icon color="#D97706" size="24">mdi-information-outline</v-icon>
          </div>
          <div class="notice-content">
            <h4>안내사항</h4>
            <p>참여 기업이 아닌 경우에는 상담이 어려울 수 있는 점 양해 부탁드립니다.</p>
          </div>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="submit-button" :disabled="isSubmitting">상담 신청하기</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultationForm',
  data() {
    return {
      isSubmitting: false,
      formData: {
        contactName: '',
        companyName: '',
        phone: '',
        position: '',
        email: '',
        isExportVoucher: null,
      },
    };
  },
  computed: {
    isFormValid() {
      const { contactName, companyName, phone, position, email, isExportVoucher } = this.formData;
      return contactName && companyName && phone && position && email && isExportVoucher !== null;
    },
  },
  methods: {
    async submitForm() {
      window.dataLayer.push({
        event: 'clickButton',
        page: 'exportVoucher',
        objectSection: 'bottom',
        objectType: 'button',
        objectId: 'submitLeadForm',
        objectName: '상담 신청하기',
      });

      if (!this.isFormValid) {
        alert('모든 필수 항목을 입력해주세요.');
        return;
      }

      this.isSubmitting = true;

      try {
        // API 호출 로직
        await this.submitConsultation(this.formData);

        window.dataLayer.push({
          event: 'completeLeadSubmission',
          page: 'exportVoucher',
          isExportVoucher: this.formData.isExportVoucher,
        });

        // 성공 처리
        this.$emit('form-submitted', this.formData);
        this.resetForm();
        alert('무료 상담 신청이 완료되었습니다.');
        this.$router.go(0); // 새로고침
      } catch (error) {
        console.error('Form submission error:', error);
        // 에러 처리
      } finally {
        this.isSubmitting = false;
      }
    },

    async submitConsultation() {
      console.log(this.formData);
      // 실제 API 호출 로직 구현

      await this.axios.post('/superchart/export-voucher-inquiry', {
        name: this.formData.contactName,
        company: this.formData.companyName,
        phone: this.formData.phone,
        position: this.formData.position,
        email: this.formData.email,
        is_export_voucher_participant: this.formData.isExportVoucher ? true : false,
      });
    },

    resetForm() {
      this.formData = {
        contactName: '',
        companyName: '',
        phone: '',
        position: '',
        email: '',
        isExportVoucher: '',
      };
    },
  },
};
</script>

<style scoped>
.consultation-form-container {
  padding: 100px 16px;

  @media (max-width: 960px) {
    padding: 56px 16px;
  }
}

.consultation-form-title {
  color: #21232e;
  text-align: center;
  font-size: 30px;
  font-weight: 800;
  line-height: 42px; /* 140% */

  @media (max-width: 960px) {
    font-size: 24px;
    line-height: 30px;
  }
}

.consultation-form-description {
  color: #1b2b43;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px; /* 175% */

  @media (max-width: 960px) {
    font-size: 14px;
    line-height: 24px;
  }
}

.consultation-form {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  max-width: 480px;
  margin: 0 auto;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  @media (max-width: 960px) {
    gap: 16px;
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

label {
  color: #757575;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}

label.selected {
  color: #2196f3 !important;
}

.form-input {
  height: 40px;
  padding: 10px 12px;
  border: 1px solid #c0c0c0;
  border-radius: 4px;

  background: #ffffff;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}

.form-input:focus {
  outline: none;
  border-color: #2196f3;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.radio-label {
}

.radio-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
}

.radio-option:hover {
  border-color: #2196f3;
  background: #f3f8ff;
}

.radio-option.selected {
  color: #2196f3 !important;
  border-color: #2196f3;
  background: #fff;
}

.radio-option input[type='radio'] {
  margin: 0;
  accent-color: #2196f3;
}

.radio-text {
  color: #c2c2c2;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
}

.notice-section {
  display: flex;
  gap: 8px;
  padding: 12px;
  background: #fffbeb;
  border-radius: 8px;
}

.notice-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.notice-content h4 {
  color: #92400e;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
}

.notice-content p {
  color: #92400e;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
}

.submit-button {
  width: 100%;
  height: 52px;
  padding: 16px 24px;
  background: #f53c4b;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;

  color: #fff;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 768px) {
  .consultation-form {
    padding: 24px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
</style>
